// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var section = "DetailsPageLayout-module--section--3Wb59";
export var container = "DetailsPageLayout-module--container--3R7Xu";
export var image = "DetailsPageLayout-module--image--3MRuC";
export var imageTitleContainer = "DetailsPageLayout-module--imageTitleContainer--3qB0W";
export var imageTitle = "DetailsPageLayout-module--imageTitle--LwgTB";
export var titleAndBarsContainer = "DetailsPageLayout-module--titleAndBarsContainer--cLFqq";
export var barsContainer = "DetailsPageLayout-module--barsContainer--29MbJ";
export var title = "DetailsPageLayout-module--title--1PDFA";
export var detailsContainer = "DetailsPageLayout-module--detailsContainer--3ZKqX";
export var tagContainer = "DetailsPageLayout-module--tagContainer--Qasze";
export var categoryIcon = "DetailsPageLayout-module--categoryIcon--2mvgn";
export var categoryTitle = "DetailsPageLayout-module--categoryTitle--20pBw";
export var date = "DetailsPageLayout-module--date--1RFa8";
export var blexiaProductTitle = "DetailsPageLayout-module--blexiaProductTitle--1-cy3";
export var blexiaLogo = "DetailsPageLayout-module--blexiaLogo--RhHL9";
export var titleDivider = "DetailsPageLayout-module--titleDivider--2c5qj";
export var content = "DetailsPageLayout-module--content--xml7J";
export var topLinksContainer = "DetailsPageLayout-module--topLinksContainer--2Zdk_";
export var link = "DetailsPageLayout-module--link--2ej6H";
export var iconLeft = "DetailsPageLayout-module--iconLeft--2t6Cb";
export var iconRight = "DetailsPageLayout-module--iconRight--ANe3W";
export var articlesBody = "DetailsPageLayout-module--articlesBody--n0eiP";
export var productPageBody = "DetailsPageLayout-module--productPageBody--2fVsV";
export var overlay = "DetailsPageLayout-module--overlay--8QNTh";
export var shareCardWrapper = "DetailsPageLayout-module--shareCardWrapper--2p-zj";
export var shareButtonBottomContainer = "DetailsPageLayout-module--shareButtonBottomContainer--32TYe";
export var animatebottom = "DetailsPageLayout-module--animatebottom--2Yr1K";